function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgLogoutButton = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("g", {
  transform: "translate(1223.5 -16554.57)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: -1211.5,
  cy: 16566.6,
  r: 11.7,
  style: {
    opacity: 0.25,
    fill: "#e02424"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M-1211.3 16567.1c.3 0 .6-.3.6-.6v-4.8c0-.3-.3-.6-.6-.6s-.6.3-.6.6v4.8c.2.4.3.6.6.6m3.4-4.4c-.1-.1-.3-.1-.3-.1-.3 0-.6.3-.6.6 0 .1.1.3.1.3 1.8 1.5 1.9 4.2.4 5.9-1.5 1.8-4.2 1.9-5.9.4-1-.8-1.5-1.9-1.5-3.1 0-1.3.6-2.4 1.5-3.2.3-.1.3-.6 0-.7-.1-.3-.6-.3-.7 0-1.3 1-1.9 2.4-1.9 3.9 0 2.8 2.3 5.3 5.2 5.3 2.8 0 5.3-2.3 5.3-5.2.3-1.7-.4-3.1-1.6-4.1",
  style: {
    fill: "#e02424"
  }
})));
export default SvgLogoutButton;